import {
	MemberGrowthOpportunitiesV3,
	ConfidenceLevel,
	KeyResultType
} from "@teaming/common-enums";

export default ( { i18n, } ) => {
	// eslint-disable-next-line no-magic-numbers
	return ( { personId, leadId, goalId, opportunity, onboardingVersion = 3, } ) => {
		const MemberGrowthOpportunities = MemberGrowthOpportunitiesV3;

		if ( !MemberGrowthOpportunities.includes( opportunity ) ) {
			throw new Error( "not a valid member opportunity" );
		}

		const resolveKeyResultType = () => {
			if ( [
				MemberGrowthOpportunities.BURNOUT,
				MemberGrowthOpportunities.DIFFICULT_CONVERSATIONS,
			].includes( opportunity ) ) {
				return KeyResultType.BINARY;
			}
			return KeyResultType.NUMERIC;
		};

		const endValueMap = {
			[ MemberGrowthOpportunities.CAREER_PLAN ]: 6,
			[ MemberGrowthOpportunities.WORK_PRIORITY ]: 20,
			[ MemberGrowthOpportunities.BURNOUT ]: 1,
			[ MemberGrowthOpportunities.DIFFICULT_CONVERSATIONS ]: 1,
			[ MemberGrowthOpportunities.SOLICIT_FEEDBACK ]: 4,
			[ MemberGrowthOpportunities.RELATIONSHIPS ]: 5,
			[ MemberGrowthOpportunities.WORK_VALUE ]: 12,
		};

		const resolveOwner = () => {
			return opportunity === MemberGrowthOpportunities.WORK_VALUE ?
				[ leadId, ] :
				[ personId, ];
		};

		const nameKeys = {
			3: `common-gokr.domain.keyResultTitle${ opportunity }`,
		};
		const nameKey = nameKeys[ onboardingVersion ] || "";

		return {
			name: i18n.global.t( nameKey ),
			type: resolveKeyResultType(),
			currentValue: 0,
			goalValue: endValueMap[ opportunity ],
			goalId,
			owners: resolveOwner(),
			confidence: ConfidenceLevel.HIGH,
			sortOrder: 0,
		};
	};
};
